<template>
	<Carousel :value="itemList" :num-visible="1" :num-scroll="1" :showIndicators="false" :autoplay-interval="8000" circular>
		<template #item="{ data }">
			<div class="testimonial-container">
				<div class="testimonial" v-html="data.Content"></div>
				<div class="cite">{{ data.Cite }}</div>
			</div>
		</template>
	</Carousel>
</template>
<script lang="ts" setup>
	import Carousel from 'primevue/carousel';
	import { onMounted, ref } from 'vue';

	interface TestimonialItemModel {
		Content: string;
		Cite: string;
	}

	const props = defineProps({
		items: {
			type: String,
			required: true,
		},
	});

	const itemList = ref<TestimonialItemModel[]>([]);

	onMounted(() => {
		itemList.value = JSON.parse(props.items);
	});
</script>
